import { DraftElement } from '@atom/types/ai';

import ChatAssetDraftElementRow from './ChatAssetDraftElementRow';

import classes from '../chat.module.css';

type ChatAssetDraftElementsProps = {
  elements: DraftElement[];
  path: (string | number)[];
  isTopLevel?: boolean;
};

const ChatAssetDraftElements = ({
  elements,
  path,
  isTopLevel = false,
}: ChatAssetDraftElementsProps) => {
  if (!elements.length) {
    return null;
  }

  return (
    <div className={classes.assetDraftCardElements}>
      {isTopLevel && (
        <div className={classes.assetDraftCardElementsHeader}>Sub items</div>
      )}
      {elements.map((element, index) => (
        <ChatAssetDraftElementRow
          key={index}
          element={element}
          path={[...path, 'elements', index]}
        />
      ))}
    </div>
  );
};

export default ChatAssetDraftElements;
